import React, { Component } from 'react';
import '../App.css';
import { observer, inject } from 'mobx-react';

class SurveyList extends Component {
  handleClick = (event) => {
    if (event.target.innerHTML === 'Survey #1') {
      this.props.StateStore.changeRoute('survey1');
      setTimeout(function () {
        var elmnt = document.getElementById('surveyStart');
        elmnt.scrollIntoView();
      }, 500);
    }

    if (event.target.innerHTML === 'Survey #2') {
      this.props.StateStore.changeRoute('survey2');
      setTimeout(function () {
        var elmnt = document.getElementById('surveyStart');
        elmnt.scrollIntoView();
      }, 500);
    }
  };

  render() {
    return (
      <div className='container left-alignment'>
        <h2>Choose a Survey Question</h2>
        <hr className='left-align' />
        <ul className='surveyList'>
          <li>
            <a href='#top' onClick={this.handleClick}>
              <h4>Survey #1</h4>
            </a>
          </li>
          <li>
            <a href='#top' onClick={this.handleClick}>
              <h4>Survey #2</h4>
            </a>
          </li>
        </ul>
      </div>
    );
  }
}

export default inject('StateStore')(observer(SurveyList));
